export const fetchCapital = async (countryName) => {
  const response = await fetch(
    `https://restcountries.com/v3.1/name/${countryName}?fullText=true`
  );

  if (!response.ok) {
    throw new Error('Failed to fetch capital data');
  }

  const data = await response.json();
  const capital = data[0].capital[0];

  const normalized = capital
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[.,'/]/g, "")
    .replace(/[_-]/g, " ");

  return {
    normalized,
    display: capital
  };
};